import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { GetPageById, AddPage } from '../services/pageservice';
import slugify from 'slugify';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

function PageNew() {
    const [title, setTitle] = useState('');
    const [paramlink, setParamLink] = useState('');
    const [metatitle, setMetaTitle] = useState('');
    const [metadesc, setMetaDesc] = useState('');
    const [metakeywords, setMetaKeywords] = useState('');
    const [section1, setSection1] = useState('');
    const [section2, setSection2] = useState('');
    const [section3, setSection3] = useState('');
    const [metafor, setMetaFor] = useState(1);
    const [ownerPk, setOwnerPk] = useState();

    const [pk, setPk] = useState(0);
    let navigate = useNavigate();  
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const id = queryParams.get('pk') || null; // e.g., ?id=18
    
    useEffect(() => {
        console.log("id", id);
        if(id != null)
            {
                fillData (id);
                setPk(id);
            }
    }, []); 

        const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6] }],
            ['bold', 'italic', 'underline', 
                //'strike'
            ],
            [
                { color: [] }, 
                //{ background: [] }
            ],
            //[{ font: [] }],
           // [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            //[{ indent: '-1' }, { indent: '+1' }],
            ['blockquote', 'code-block'],
            //['link', 'image', 'video'],
            //['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', //'strike',
        'color', 'background',
        //'font', 'align',
        'list', 'bullet', 'indent',
        'blockquote', 'code-block',
        //'link', 'image', 'video'
    ];

    const fillData  = async (pk) => {
        try {
            const pageDetail = await GetPageById(pk);
            const jsonData = JSON.parse(pageDetail);
            
            setTitle(jsonData.title);
            setParamLink(jsonData.paramlink);
            setMetaTitle(jsonData.metatitle); 
            setMetaDesc(jsonData.metadesc);
            setMetaKeywords(jsonData.metakeywords);
            setSection1(jsonData.section1text);
            setSection2(jsonData.section2text);
            setSection3(jsonData.section3text);

          } catch (error) {
            console.error('Error fetching the data:', error);
          }
    }

    const handleSave = async () => {
        try {
            const response = AddPage(
                JSON.stringify({
                    Pk: pk,
                    title:title,
                    paramlink: paramlink,
                    metatitle: metatitle,
                    metadesc: metadesc,
                    metakeywords: metakeywords,
                    section1text: section1,
                    section2text: section2,
                    section3text: section3,
                    metafor: metafor,
                    ownerPk: ownerPk
                }));

            if(pk == 0)
                navigate('/pages', { state: { successMessage: 'New page record added' } });
            else
                navigate('/pages', { state: { successMessage: 'Page record updated' } });

        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    const handleCancel = async () => {
        navigate('/pages');
    }

    return (
        <>
            <div class="row">
                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Add new page</h4>
                            
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label for="txtName">Meta For</label>
                                    <input type="text"  class="form-control" 
                                    id="txtMetaFor" 
                                    value="Page" disabled/>
                                </div>

                                <div class="form-group">
                                    <label for="txtName">Name</label>
                                    <input type="text" 
                                    class="form-control" 
                                    id="txtName" 
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Name" 
                                    value={title}/>
                                </div>

                                <div class="form-group">
                                    <label for="txtParamLink">Param Link</label>
                                    <input type="text" 
                                    class="form-control" 
                                    onChange={(e) => setParamLink(e.target.value)}
                                    id="txtParamLink" 
                                    placeholder="Param Link" 
                                    value={paramlink} />
                                </div>
                               
                               <div class="form-group">
                                    <label for="txtmetatitle">Meta Title</label>
                                    <input type="text" 
                                    class="form-control" 
                                    onChange={(e) => setMetaTitle(e.target.value)}
                                    id="txtmetatitle" 
                                    placeholder="Meta Title"
                                     value={metatitle} />
                                </div>

                                <div class="form-group">
                                    <label for="txtmetadesc">Meta Desc</label>
                                    <input type="text" 
                                    class="form-control" 
                                    onChange={(e) => setMetaDesc(e.target.value)}
                                    id="txtmetadesc" 
                                    placeholder="Meta Desc" 
                                    value={metadesc} />
                                </div>

                                 <div class="form-group">
                                    <label for="txtmetakeywords">Meta Keywords</label>
                                    <input type="text" 
                                    class="form-control" 
                                    id="txtmetakeywords" 
                                    onChange={(e) => setMetaKeywords(e.target.value)}
                                    placeholder="Meta Keywords" 
                                    value={metakeywords} />
                                </div>

                                <button type="button" class="btn btn-primary me-2" onClick={() => handleSave() }>Submit</button>
                                <button class="btn btn-light" onClick={() => handleCancel() }>Cancel</button>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">&nbsp;</h4>
                            <form class="forms-sample">
                                <div class="form-group small-quill">
                                    <label>Section 1 Text</label>
                                    <ReactQuill
                                        theme="snow"
                                        id="txtsection1"
                                        value={section1}
                                        onChange={(section1) => setSection1(section1)}
                                        modules={modules}
                                        formats={formats}
                                        placeholder="Start typing..."
                                        height={100}
                                    />
                                    <div className="output">
                                        <h3>Output HTML:</h3>
                                        <div className='dropcap-paragraph' dangerouslySetInnerHTML={{ __html: section1 }} />
                                    </div>
                                    {/* <textarea
                                        className="form-control"
                                        id="txtsection1"
                                        onChange={(e) => setSection1(e.target.value)}
                                        placeholder="Section 1 Text"
                                        rows="7"
                                        value={section1}
                                        /> */}
                                </div>

                                <div class="form-group small-quill">
                                    <label for="txtsection2">Section 2 Text</label>
                                    <ReactQuill
                                        theme="snow"
                                        id="txtsection2"
                                        value={section2}
                                        onChange={(section2) => setSection2(section2)}
                                        modules={modules}
                                        formats={formats}
                                        placeholder="Start typing..."
                                        height={100}
                                    />
                                    <div className="output">
                                        <h3>Output HTML:</h3>
                                        <div className='dropcap-paragraph' dangerouslySetInnerHTML={{ __html: section2 }} />
                                    </div>
                                    {/* <textarea
                                        className="form-control"
                                        id="txtsection2"
                                        onChange={(e) => setSection2(e.target.value)}
                                        placeholder="Section 2 Text"
                                        rows="7"
                                        value={section2}
                                        /> */}
                                </div>
                               
                               <div class="form-group small-quill">
                                    <label for="txtsection3">Section 3 Text</label>
                                    <ReactQuill
                                        theme="snow"
                                        id="txtsection3"
                                        value={section3}
                                        onChange={(section3) => setSection3(section3)}
                                        modules={modules}
                                        formats={formats}
                                        placeholder="Start typing..."
                                        height={100}
                                    />
                                    <div className="output">
                                        <h3>Output HTML:</h3>
                                        <div className='dropcap-paragraph' dangerouslySetInnerHTML={{ __html: section3 }} />
                                    </div>
                                    {/* <textarea
                                        className="form-control"
                                        id="txtsection3"
                                        onChange={(e) => setSection3(e.target.value)}
                                        placeholder="Section 3 Text"
                                        rows="7"
                                        value={section3}
                                        /> */}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
export default PageNew;
